import { c as _c } from "react/compiler-runtime";
import { NotFound } from '@systemeio/util';
import { PAYPAL_REST_API } from 'modules/profile/payment-gateways/integrations/paypal-rest/api';
import { PaypalRestMessagesInterface } from 'modules/profile/payment-gateways/integrations/paypal-rest/types';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
export const usePaypalRestMessages = () => {
  const $ = _c(2);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = {
      method: RequestMethodsEnum.get,
      onErrorBeforeErrorHandlers: error => {
        if (error instanceof NotFound) {
          return {
            messages: [t("dashboard.settings.payment_gateways.paypal_integration_not_found")]
          };
        }
        throw error;
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    fetcher
  } = useFetch(t0);
  return useControlledSwr(`${PAYPAL_REST_API}/onboarding/status`, fetcher, undefined, !!user);
};